import { AxiosResponse } from "axios";

import DiagnosticLogsApi from "./diagnostic-logs-api";
import { ScmaxUlogRecord } from "../types";

export type GetSCMaxULogsRecordsParams = {
    mac_address: string;
    rids?: string[];
    start_date?: string;
    end_date?: string;
    page?: number;
    page_size?: number;
};


type PageRecordResponse = {
    items: ScmaxUlogRecord[];
    count: number;
    page: number;
    pageSize: number;
};


export const getSCMaxULogsRecords = async (
    params: GetSCMaxULogsRecordsParams
): Promise<PageRecordResponse> => {
    // format: link
    const { rids, ...otherParams } = params
    const typesString = (rids || [])?.map(type => `rids=${type}`).join('&') + ""
    const response: AxiosResponse<PageRecordResponse> = await DiagnosticLogsApi.get(
        `scmax/ulog/records-by-mac-addr?${typesString}`,
        {
            params: otherParams,
        }
    );

    return response.data;
};


export default {
    getSCMaxULogsRecords
}
